import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  button: {
    marginHorizontal: 11,
    marginVertical: 32,
  },
  containerStyle: {
    paddingHorizontal: 10,
  },
  buttonTextStyle: {
    marginTop: Platform.OS == 'ios' ? 4 : 0,
  },
  disabledBUttonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  disabledTextStyle: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
  labelTextStyle: {
    fontFamily: Fonts.type.VFFont,
  },
  passwordInputStyle: {
    marginTop: 15,
  },
});
